export const commonPageStylesIdentifier = 'g-CommonPageStyes';

export const systemStatusMap = {
  operational: {
    title: 'All Systems Operational',
    label: 'Operational',
    color: 'var(--success)',
    badgeColor: {
      text: 'text-green-800',
      background: 'bg-green-100',
    },
  },
  degraded_performance: {
    title: 'Degraded Performance',
    label: 'Degraded Performance',
    color: 'var(--warning)',
    badgeColor: {
      text: '!text-yellow-800',
      background: 'bg-yellow-100',
    },
  },
  partial_outage: {
    title: 'Partial Outage',
    label: 'Partial Outage',
    color: 'var(--test)',
    badgeColor: {
      text: '!text-orange-800',
      background: 'bg-orange-100',
    },
  },
  major_outage: {
    title: 'Major Outage',
    label: 'Major Outage',
    color: 'var(--error)',
    badgeColor: {
      text: '!text-orange-800',
      background: 'bg-orange-100',
    },
  },
  maintenance: {
    title: 'Maintenance',
    label: 'Maintenance',
    color: 'var(--informative)',
    badgeColor: {
      text: '!text-blue-800',
      background: 'bg-blue-100',
    },
  },
} as const;

/**
 * Tailwind gap scale values.
 * Supports all default Tailwind spacing values.
 */
export type SizeScales =
  | 0
  | 0.5
  | 1
  | 1.5
  | 2
  | 2.5
  | 3
  | 3.5
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 14
  | 16
  | 20
  | 24
  | 28
  | 32
  | 36
  | 40
  | 44
  | 48
  | 52
  | 56
  | 60
  | 64
  | 72
  | 80
  | 96;
